const networkErrorMessages = [
  // common network error codes
  'net::ERR_FAILED', // chrome
  'net::ERR_NETWORK', // chrome (Captures e.g. ERR_NETWORK_CHANGED)
  'net::ERR_CONNECTION_ABORTED', // chrome
  'net::ERR_CONNECTION_REFUSED', // chrome
  'net::ERR_CONNECTION_RESET',
  'net::ERR_CONNECTION_TIMED_OUT', // chrome
  'net::ERR_INTERNET_DISCONNECTED', // chrome
  'net::ERR_INCOMPLETE_CHUNKED_ENCODING', // chrome
  'net::ERR_NAME_NOT_RESOLVED', // chrome
  'net::ERR_ADDRESS_UNREACHABLE', // chrome
  'net::ERR_TIMED_OUT',
  'net::ETIMEDOUT',
  'net::ECONNREFUSED',
  'net::ECONNRESET',
  'net::ENOTFOUND',

  // common network error messages
  'Failed to fetch', // general fetch error
  'NetworkError', // general
  'Network request failed', // general XmlHttpRequest error
  'The Internet connection appears to be offline',
  'Network error occurred',
  "The operation couldn't be completed", // firefox
  'The operation was aborted', // firefox
  'A network error occurred',
  'Load failed', // generic
].map((msg) => msg.toLowerCase());

export function isNetworkError(error: unknown): boolean {
  if (!(error instanceof TypeError)) {
    return false;
  }

  const message = error.message.toLowerCase();
  return networkErrorMessages.some((msg) => message.includes(msg));
}
